import type { ActionRegisterResponse } from '@risksmart-app/trpc/src/types';
import type { GetActionsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetActionsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetActionsByParentIdRegisterArgs = {
  parentId: string;
};

export const useLazyGetActionsByParentIdRegister = createLazyQueryHook<
  UseLazyGetActionsByParentIdRegisterArgs,
  ActionRegisterResponse,
  GetActionsQuery
>({
  trpcQuery: (client, { parentId }) =>
    client.frontend.action.register.query({ parentId }),
  mapTrpcDataToGraphQL: (data) => ({ action: data.action }),
  graphqlDocument: GetActionsDocument,
  graphqlVariables: ({ parentId }) => ({
    where: {
      parents: {
        ParentId: {
          _eq: parentId,
        },
      },
    },
  }),
});
